import { Icon } from "pepsico-ds";

const RenderActions = (row, onClick) => {
  return (
    <Icon
      alt={row ? "Collapse" : "Expand"}
      className="$color-icon-default"
      icon={row ? "keyboard_arrow_up" : "keyboard_arrow_down"}
      size="medium"
      style={{ color: "black" }}
      data-testid="icon"
      onClick={onClick}
    />
  );
};

export default RenderActions;
